module.exports = __webpack_public_path__ + "static/37import-0686aaa268545c34203b0f3cb938fbba.png";